import React from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import FooterNew from "../Components/FooterNew";
import QuickLinks from "./QuickLinks";

const SkinCancerAwareness = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;
  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }}>
      <Navbar />
      <div className="Main-Header-Container">
        <section
          className="py-xxl-10 pb-0"
          id="home"
          style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
        >
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url(${heroBgImage})`,
              backgroundPosition: "bottom",
              backgroundSize: "cover",

              //   height: "100vh", // Add a height to ensure background is visible
            }}
          />

          <div className="container">
            <div className="row min-vh-xl-100 min-vh-xxl-25">
              <div className=" paddin-header   text-center ">
                <h2 className="">
                  <span
                    className=" general-tittle-mbl"
                    style={{
                      fontSize: "48px",
                      fontFamily: "Raleway, sanf-serif",
                      color: "#fff",
                      paddingBottom: " 10px",
                    }}
                  >
                    Skin Cancer Awareness
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="Genral-main-container text-center py-5">
        <h1 style={{ color: "#adb5bd", fontFamily: "'Raleway', sans-serif" }}>
          Information coming soon.
        </h1>
      </div>
      <div className="footer-import ">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default SkinCancerAwareness;
